import type { Route } from './router';

// Cargadores perezosos/directos de páginas
import { LoginPage } from '../pages/login';
import { DashboardPage } from '../pages/dashboard';
import { DailyRoutinePage } from '../pages/daily-routine';
import { RoutinesHistoryPage } from '../pages/routines-history';
import { MeasuresPage } from '../pages/measures';
import { AttendancePage } from '../pages/attendance';
import { PaymentsPage } from '../pages/payments';
import { RankingsPage } from '../pages/rankings';
import { ProfilePage } from '../pages/profile';
import { WorkoutSessionPage } from '../pages/workout-session';
import { WorkoutHistoryPage } from '../pages/workout-history';
import { AdminStudentsPage } from '../pages/admin-students';
import { AdminStudentDetailPage } from '../pages/admin-student-detail';
import { AdminPaymentsPage } from '../pages/admin-payments';
import { AdminExercisesPage } from '../pages/admin-exercises';
import { AdminMachinesPage } from '../pages/admin-machines';
import { AdminRoutinesPage } from '../pages/admin-routines';
import { AdminRoutinePage } from '../pages/admin-routine';
import { AdminRoutineTemplatesPage } from '../pages/admin-routine-templates';
import { AdminRoutineTemplatePage } from '../pages/admin-routine-template';
import { AdminMeasuresPage } from '../pages/admin-measures';
import { AdminAttendancePage } from '../pages/admin-attendance';
import { AdminRankingsPage } from '../pages/admin-rankings';
import { AdminGlobalWorkoutHistoryPage } from '../pages/admin-global-workout-history';

export const routes: Route[] = [
  {
    path: '/',
    requiresAuth: true,
    component: () => new DashboardPage(),
  },
  {
    path: '/login',
    guestOnly: true,
    component: () => new LoginPage(),
  },
  {
    path: '/dashboard',
    requiresAuth: true,
    component: () => new DashboardPage(),
  },
  // Admin/Coach routes — Sprint 6: COACH habilitado donde la API lo permite
  {
    path: '/admin/students',
    requiresAuth: true,
    allowedRoles: ['ADMIN', 'COACH'],
    component: () => new AdminStudentsPage(),
  },
  {
    path: '/admin/student',
    requiresAuth: true,
    allowedRoles: ['ADMIN', 'COACH'],
    component: () => new AdminStudentDetailPage(),
  },
  {
    path: '/admin/payments',
    requiresAuth: true,
    allowedRoles: ['ADMIN'],
    component: () => new AdminPaymentsPage(),
  },
  {
    path: '/admin/exercises',
    requiresAuth: true,
    allowedRoles: ['ADMIN', 'COACH'],
    component: () => new AdminExercisesPage(),
  },
  {
    path: '/admin/machines',
    requiresAuth: true,
    allowedRoles: ['ADMIN'],
    component: () => new AdminMachinesPage(),
  },
  {
    path: '/admin/routines',
    requiresAuth: true,
    allowedRoles: ['ADMIN', 'COACH'],
    component: () => new AdminRoutinesPage(),
  },
  {
    path: '/admin/routine',
    requiresAuth: true,
    allowedRoles: ['ADMIN', 'COACH'],
    component: () => new AdminRoutinePage(),
  },
  {
    path: '/admin/routine-templates',
    requiresAuth: true,
    allowedRoles: ['ADMIN', 'COACH'],
    component: () => new AdminRoutineTemplatesPage(),
  },
  {
    path: '/admin/routine-template',
    requiresAuth: true,
    allowedRoles: ['ADMIN', 'COACH'],
    component: () => new AdminRoutineTemplatePage(),
  },
  {
    path: '/admin/measures',
    requiresAuth: true,
    allowedRoles: ['ADMIN', 'COACH'],
    component: () => new AdminMeasuresPage(),
  },
  {
    path: '/admin/attendance',
    requiresAuth: true,
    allowedRoles: ['ADMIN', 'COACH'],
    component: () => new AdminAttendancePage(),
  },
  {
    path: '/admin/rankings',
    requiresAuth: true,
    allowedRoles: ['ADMIN', 'COACH'],
    component: () => new AdminRankingsPage(),
  },
  {
    path: '/admin/workout-history',
    requiresAuth: true,
    allowedRoles: ['ADMIN'],
    component: () => new AdminGlobalWorkoutHistoryPage(),
  },
  // Student routes
  {
    path: '/daily-routine',
    requiresAuth: true,
    allowedRoles: ['STUDENT'],
    component: () => new DailyRoutinePage(),
  },
  {
    path: '/routines',
    requiresAuth: true,
    allowedRoles: ['STUDENT'],
    component: () => new RoutinesHistoryPage(),
  },
  {
    path: '/measures',
    requiresAuth: true,
    allowedRoles: ['ADMIN', 'COACH', 'STUDENT'],
    component: () => new MeasuresPage(),
  },
  {
    path: '/attendance',
    requiresAuth: true,
    allowedRoles: ['STUDENT'],
    component: () => new AttendancePage(),
  },
  {
    path: '/payments',
    requiresAuth: true,
    allowedRoles: ['STUDENT'],
    component: () => new PaymentsPage(),
  },
  {
    path: '/rankings',
    requiresAuth: true,
    allowedRoles: ['STUDENT'],
    component: () => new RankingsPage(),
  },
  {
    path: '/profile',
    requiresAuth: true,
    allowedRoles: ['STUDENT'],
    component: () => new ProfilePage(),
  },
  {
    path: '/workout',
    requiresAuth: true,
    allowedRoles: ['STUDENT'],
    component: () => new WorkoutSessionPage(),
  },
  {
    path: '/workout-history',
    requiresAuth: true,
    allowedRoles: ['STUDENT'],
    component: () => new WorkoutHistoryPage(),
  },
];
